import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class XMapService {

    dwTrapGif: any;

    constructor(
      private utilService: UtilsService
    ) {}
    districtPanel(): any[] {
        return [{id: 310114, name: '嘉定区', data: [{type: 'image', x: 146, y: 263, w: 167, h: 187}, {type: 'text', name: '嘉定', x: 213.526, y: 352.268}]}, {id: 310113, name: '宝山区', data: [{type: 'image', x: 272, y: 256, w: 140, h: 158}, {type: 'text', name: '宝山', x: 328.526, y: 332.267}]}, {id: 310115, name: '浦东新区', data: [{type: 'image', x: 373, y: 335, w: 314, h: 376}, {type: 'text', name: '浦东', x: 503, y: 510}]}, {id: 310151, name: '崇明区', data: [{type: 'image', x: 248, y: 69, w: 430, h: 242}, {type: 'image', x: 473, y: 302, w: 174, h: 94}, {type: 'text', name: '崇明', x: 452.525, y: 222.268}]}, {id: 310110, name: '杨浦区', data: [{type: 'image', x: 396, y: 350, w: 64, h: 80}, {type: 'text', name: '杨浦', x: 414, y: 389}]}, {id: 310107, name: '普陀区', data: [{type: 'image', x: 270, y: 383, w: 100, h: 71}, {type: 'text', name: '普陀', fs: 14, x: 316, y: 428}]}, {id: 310112, name: '闵行区', data: [{type: 'image', x: 218, y: 426, w: 221, h: 198}, {type: 'text', name: '闵行', x: 325, y: 559}]}, {id: 310104, name: '徐汇区', data: [{type: 'image', x: 319, y: 448, w: 75, h: 100}, {type: 'text', name: '徐汇', x: 341, y: 496}]}, {id: 310118, name: '青浦区', data: [{type: 'image', x: -21, y: 400, w: 296, h: 241}, {type: 'text', name: '青浦', x: 146, y: 471}]}, {id: 310117, name: '松江区', data: [{type: 'image', x: 90, y: 492, w: 226, h: 182}, {type: 'text', name: '松江', x: 203, y: 592}]}, {id: 310116, name: '金山区', data: [{type: 'image', x: 68, y: 627, w: 308, h: 186}, {type: 'text', name: '金山', x: 240, y: 720}]}, {id: 310120, name: '奉贤区', data: [{type: 'image', x: 307, y: 595, w: 277, h: 157}, {type: 'text', name: '奉贤', x: 421, y: 664}]}, {id: 310109, name: '虹口区', data: [{type: 'image', x: 374, y: 374, w: 46, h: 60}, {type: 'text', name: '虹', x: 383, y: 399, fs: 14, tspan: {x: 423, dy: 14, txt: '口'}}]}, {id: 310101, name: '黄浦区', data: [{type: 'image', x: 374, y: 429, w: 41, h: 47}, {type: 'text', name: '黄浦', fs: 12, x: 384, y: 459}]}, {id: 310105, name: '长宁区', data: [{type: 'image', x: 276, y: 430, w: 82, h: 56}, {type: 'text', name: '长宁', fs: 14, x: 308, y: 468}]}, {id: 310106, name: '静安区', data: [{type: 'image', x: 339, y: 368, w: 55, h: 92}, {type: 'text', name: '静', fs: 14, x: 358, y: 399, tspan: {txt: '安', x: 398, dy: 16}}]}];
    }
    getMapOptions(obj: any = {}) {
      obj.mapTypeId = window.qq.maps.MapTypeId.ROADMAP;
      if (this.utilService.isWx()) {
        obj.disableDefaultUI = true;
      } else {
        obj.scaleControl       = false;
        obj.mapTypeControl     = false;
        obj.panControl         = true;
        obj.zoomControl        = true;
        obj.panControlOptions  = { position: window.qq.maps.ControlPosition.RIGHT_CENTER };
        obj.zoomControlOptions = { position: window.qq.maps.ControlPosition.RIGHT_CENTER };
      }

      return obj;
    }

    dwTrapMap(mapid: number, uid: any) {
      const params = [];
      params.push('APIVersion=0.6.0');
      params.push('device=h5');
      params.push('uid=' + uid);
      params.push('uv_id=' + uid);
      params.push('scene=map');
      params.push('scene_id=' + mapid);
      params.push('uri=pages/index/index');
      params.push('search=');
      params.push('url=');

      if (!this.dwTrapGif) { this.dwTrapGif = (document.getElementById('dw-trap-gif') as HTMLImageElement); }
      this.dwTrapGif.src = environment.logHost + '?' + params.join('&');
    }

    loadQqMapJs(callback = () => {}) {
      callback();
      return;
      window.initMap = () => {
            callback();
        };
      if (!window.document.getElementById('qq-map-script')) {
            const s = window.document.createElement('script');
            s.id = 'qq-map-script';
            s.type = 'text/javascript';
            s.src = 'https://map.qq.com/api/js?v=2.exp&libraries=visualization&key=' + environment.mapKey + '&callback=initMap';
            window.document.body.appendChild(s);
        } else {
            callback();
        }
    }

    loadTMapGlJs(callback = () => {}) {
      window.initTMap = () => {
          callback();
      };
      if (!window.document.getElementById('t-map-script')) {
          const s = window.document.createElement('script');
          s.id = 't-map-script';
          s.type = 'text/javascript';
          s.src = 'https://map.qq.com/api/gljs?v=1.exp&key=' + environment.mapKey + '&callback=initTMap';
          window.document.body.appendChild(s);
      } else {
          callback();
      }
  }

    initMyOverlay(): any {
        const qq  = window.qq;
        const ydao = '<img src=\'/assets/imgs/icon/ydao.png\' style=\'position:absolute;bottom: -22.5px;left:30px;width:36px;height:22.5px;\' />';

        // 自定义Overlay代码开始 =================================================
        // 声明类,opts为类属性，初始化时传入（非必须，看实际需求）
        const myOverlay = function(opts) {
          qq.maps.Overlay.call(this, opts);
        };

        // 继承Overlay基类
        myOverlay.prototype = new qq.maps.Overlay();

        // 实现构造方法
        myOverlay.prototype.construct = function() {
          // 创建了覆盖物的容器，这里我用了一个div，并且设置了样式
          this.dom = document.createElement('div');
          this.dom.id = 'inforwin-wrapper';
          this.dom.style.cssText = 'border-radius: 8px;background-color:#ffffff;border: 2px solid #60828e;position:absolute;width:40vw;box-shadow: 6px 6px 4px #888888;z-index: 99999;';

          // 将初始化的html填入到了窗口里，这根据您自己的需要决定是否加这属性
          this.dom.innerHTML = ydao;

          // 将dom添加到覆盖物层
          this.getPanes().floatPane.appendChild(this.dom);

          const dom = document.getElementById('inforwin-wrapper') as HTMLElement;
          dom.addEventListener('touchstart', function(e: any) {
            e.stopPropagation();
          });
          dom.addEventListener('touchend', function(e: any) {
            e.stopPropagation();
          });
          dom.addEventListener('touchmove', function(e: any) {
            e.stopPropagation();
          });

          const complete = this.get('complete');
          complete();
        };

        // 实现绘制覆盖物的方法（覆盖物的位置在此控制）
        myOverlay.prototype.draw = function() {
          return; // 默认位置
          // 获取地理经纬度坐标
          const position = this.get('position');
          if (position) {
            const pixel = this.getProjection().fromLatLngToDivPixel(position);
            this.dom.style.left = pixel.getX() + 'px';
            // this.dom.style.top = pixel.getY() + 'px';
            this.dom.style.bottom = - pixel.getY() + 'px';
          }
        };
        // 实现析构方法（类生命周期结束时会自动调用，用于释放资源等）
        myOverlay.prototype.destroy = function() {
          // 移除dom
          this.dom.parentNode.removeChild(this.dom);
        };

        myOverlay.prototype.setContent = function(html){
          this.dom.innerHTML = html + ydao;
        };
        myOverlay.prototype.xsetPosition = function(position) {
          const pixel = this.getProjection().fromLatLngToDivPixel(position);
          this.dom.style.left = (pixel.getX() - 30) + 'px';
          // this.dom.style.top = pixel.getY() + 'px';
          this.dom.style.bottom = - (pixel.getY() - 60) + 'px';
        };
        // 隐藏
        myOverlay.prototype.close = function(callback = () => {}) {
          if (this.dom) { this.dom.style.display = 'none'; }
          callback();
        };
        // 显示
        myOverlay.prototype.open = function(callback = () => {}) {
          if (this.dom) { this.dom.style.display = 'block'; }
          callback();
        };

        return myOverlay;
    }

    initMyRedOverlay(): any {
      const qq  = window.qq;
      const ydao = '<img src=\'/assets/imgs/new/icon/red-ydao.png\' style=\'position:absolute;bottom: -22.5px;left:30px;width:36px;height:22.5px;\' />';

      // 自定义Overlay代码开始 =================================================
      // 声明类,opts为类属性，初始化时传入（非必须，看实际需求）
      const myOverlay = function(opts) {
        qq.maps.Overlay.call(this, opts);
      };

      // 继承Overlay基类
      myOverlay.prototype = new qq.maps.Overlay();

      // 实现构造方法
      myOverlay.prototype.construct = function() {
        // 创建了覆盖物的容器，这里我用了一个div，并且设置了样式
        this.dom = document.createElement('div');
        this.dom.id = 'inforwin-red-wrapper';
        this.dom.style.cssText = 'border-radius: 8px;background-color:#ffffff;border: 2px solid #c95b51;position:absolute;width:40vw;box-shadow: 6px 6px 4px #888888;z-index: 99999;';

        // 将初始化的html填入到了窗口里，这根据您自己的需要决定是否加这属性
        this.dom.innerHTML = ydao;

        // 将dom添加到覆盖物层
        this.getPanes().floatPane.appendChild(this.dom);

        const dom = document.getElementById('inforwin-red-wrapper') as HTMLElement;
        dom.addEventListener('touchstart', function(e: any) {
          e.stopPropagation();
        });
        dom.addEventListener('touchend', function(e: any) {
          e.stopPropagation();
        });
        dom.addEventListener('touchmove', function(e: any) {
          e.stopPropagation();
        });

        const complete = this.get('complete');
        complete();
      };

      // 实现绘制覆盖物的方法（覆盖物的位置在此控制）
      myOverlay.prototype.draw = function() {
        return; // 默认位置
        // 获取地理经纬度坐标
        const position = this.get('position');
        if (position) {
          const pixel = this.getProjection().fromLatLngToDivPixel(position);
          this.dom.style.left = pixel.getX() + 'px';
          // this.dom.style.top = pixel.getY() + 'px';
          this.dom.style.bottom = - pixel.getY() + 'px';
        }
      };
      // 实现析构方法（类生命周期结束时会自动调用，用于释放资源等）
      myOverlay.prototype.destroy = function() {
        // 移除dom
        this.dom.parentNode.removeChild(this.dom);
      };

      myOverlay.prototype.setContent = function(html){
        this.dom.innerHTML = html + ydao;
      };
      myOverlay.prototype.xsetPosition = function(position) {
        const pixel = this.getProjection().fromLatLngToDivPixel(position);
        this.dom.style.left = (pixel.getX() - 30) + 'px';
        // this.dom.style.top = pixel.getY() + 'px';
        this.dom.style.bottom = - (pixel.getY() - 60) + 'px';
      };
      // 隐藏
      myOverlay.prototype.close = function(callback = () => {}) {
        if (this.dom) { this.dom.style.display = 'none'; }
        callback();
      };
      // 显示
      myOverlay.prototype.open = function(callback = () => {}) {
        if (this.dom) { this.dom.style.display = 'block'; }
        callback();
      };

      return myOverlay;
  }

  initMyNewOverlay(): any {
    const qq  = window.qq;
    const ydao = '<img src=\'/assets/imgs/new/2022/new-ydao.png\' style=\'position:absolute;bottom: -22.5px;left:30px;width:36px;height:22.5px;\' />';

    // 自定义Overlay代码开始 =================================================
    // 声明类,opts为类属性，初始化时传入（非必须，看实际需求）
    const myOverlay = function(opts) {
      qq.maps.Overlay.call(this, opts);
    };

    // 继承Overlay基类
    myOverlay.prototype = new qq.maps.Overlay();

    // 实现构造方法
    myOverlay.prototype.construct = function() {
      // 创建了覆盖物的容器，这里我用了一个div，并且设置了样式
      this.dom = document.createElement('div');
      this.dom.id = 'inforwin-red-wrapper';
      this.dom.style.cssText = 'border-radius: 8px;background-color:#ffffff;border: 2px solid #2491ff;position:absolute;width:40vw;box-shadow: 6px 6px 4px #888888;z-index: 99999;';

      // 将初始化的html填入到了窗口里，这根据您自己的需要决定是否加这属性
      this.dom.innerHTML = ydao;

      // 将dom添加到覆盖物层
      this.getPanes().floatPane.appendChild(this.dom);

      const dom = document.getElementById('inforwin-red-wrapper') as HTMLElement;
      dom.addEventListener('touchstart', function(e: any) {
        e.stopPropagation();
      });
      dom.addEventListener('touchend', function(e: any) {
        e.stopPropagation();
      });
      dom.addEventListener('touchmove', function(e: any) {
        e.stopPropagation();
      });

      const complete = this.get('complete');
      complete();
    };

    // 实现绘制覆盖物的方法（覆盖物的位置在此控制）
    myOverlay.prototype.draw = function() {
      return; // 默认位置
      // 获取地理经纬度坐标
      const position = this.get('position');
      if (position) {
        const pixel = this.getProjection().fromLatLngToDivPixel(position);
        this.dom.style.left = pixel.getX() + 'px';
        // this.dom.style.top = pixel.getY() + 'px';
        this.dom.style.bottom = - pixel.getY() + 'px';
      }
    };
    // 实现析构方法（类生命周期结束时会自动调用，用于释放资源等）
    myOverlay.prototype.destroy = function() {
      // 移除dom
      this.dom.parentNode.removeChild(this.dom);
    };

    myOverlay.prototype.setContent = function(html){
      this.dom.innerHTML = html + ydao;
    };
    myOverlay.prototype.xsetPosition = function(position) {
      const pixel = this.getProjection().fromLatLngToDivPixel(position);
      this.dom.style.left = (pixel.getX() - 30) + 'px';
      // this.dom.style.top = pixel.getY() + 'px';
      this.dom.style.bottom = - (pixel.getY() - 60) + 'px';
    };
    // 隐藏
    myOverlay.prototype.close = function(callback = () => {}) {
      if (this.dom) { this.dom.style.display = 'none'; }
      callback();
    };
    // 显示
    myOverlay.prototype.open = function(callback = () => {}) {
      if (this.dom) { this.dom.style.display = 'block'; }
      callback();
    };

    return myOverlay;
}

    getDistrictSvg() {
      return [
        {
            id: 310114,
            name: '嘉定区',
            bgcolor: '#fcdfbd',
            popup: {x: 151.36, y: 374.93},
            data: [
                {
                    type: 'path',
                    val: 'M408.15,407.91a19.92,19.92,0,0,0-3.16,1.58c-.46.46-4.56,3.91-1.3,3.53s2.42,1.86,4.19,6.23,5.58-.09,6.6-.28,8.09.37,9,2.51-3.91,3.44-4.09,4.28,2,2.7,2.88,3.35,4.37-.28,5.12,0,2.6,2.14,2.7,3.53-1.86,4.74-2.79,5.49-3.44.19-4.19.47a5,5,0,0,0-2.23,2.23c-.74,1.21-4.47,1.12-5.4,1s-.65-2-1.21-2.05-.65,1-1.12.84-.37-1.3-1.21-1.77-3.63,1.4-4.47,2.51-4.65,4.28-5.95,5.58-4.37,1.3-10.33.37-7.07-2.6-9.3-6.23-3.63-4.09-6.79-6.33A28.23,28.23,0,0,0,365,430.58c-2.61-.47-3.53.74-4.47.37s-2.23-2.51-3.26-2.88-4.28.56-6.51.56-4.37,4.56-5.12,4.56-.56-3-4.37-2.88-6.33,4.09-7.26,4.47-2.14-1.49-3.44-1.67-1.67.37-3.07,1.12-1.77-.84-2.42-2.23-2.05-.84-2.6-.65-1.21-.65-1.95-1.67a18.34,18.34,0,0,1-1.58-3.72c1-1.58.09-4-1.12-4.37s-3.91,2.33-5.3,2.6-.65-4.47-.65-5.3,1.86-.84,1.86-.84l-.74-2.14c2.23-.19,4.56-1.77,4.74-3.16s-3.35-1.21-3.35-1.21l-3.81-5.77c1.49-1.95,1.12-3.26-.09-4.56s-3.26,0-3.72.47-4.93,1.21-5.4.74-1.21-8-1-9.4,3.26-5.77,3.35-6.51-2.14-7.26-2.6-8.19-1.95-.19-3.44.09-3.44-1-2.79-2a3.27,3.27,0,0,0,0-3.44c-.65-1.21-1.3.37-3,.84s-3.53-8.93-2.6-9.77,2.05,1.67,4.65.19-.19-3.72.19-5.12,10.05-2.7,11.16-4.19,3.53-.37,4.37-.74.93-.28,1.3-1-1.67-4.56,0-7.63a34,34,0,0,1,4.65-6.05c.19-.28-.09-1.67-3.07-3.53s-2.42-4.56-.84-5.67,7.26-.19,7.35-2.7-3.53-1.77-5.77-2.33-2.7-2.7-2.51-5.12,5.86-4.65,7.72-4.56,10.88,1.4,11.81-3.26,2.88-7.72,6.51-8.65,2.23-3,3.53-4.19,4.37-.84,5.49-.19,3.26.65,4.84.47,2-1,2.14-5.3,6-5.67,7.07-1.3,3,5.67,6.14,6.23,3.16-2.6,4.09-3.72,2.88-2.6,7.26-2.79a48.1,48.1,0,0,0,8.93-1.12c.93-.28,2.79-3.19,3.07-3.26a2.07,2.07,0,0,1,1.4.28c.3.28,6.14,6.05,7.26,10.51s-1.12,7.26.56,10.79,8.56,11.35,9.12,16,.74,5.95-.37,6.7-3.16.74-3.16,1.86.56,3.72-.74,4.09-6.51.19-6.14,5.21,1.86,5.95,4.09,8.93.93,4.84,1.86,6.51,4.47,2.42,5.21,6.33-2.23,7.07-1.49,10.05,5.4,3.16,5.95,4.84-3,2.6-2.6,3.72,4.47,7.63,1.3,11.53-6.88,8.74-6.14,12.09a7.62,7.62,0,0,0,4.84-1.86Z',
                },
                {
                    type: 'text',
                    name: '嘉定',
                    x: 151.36,
                    y: 374.93
                }]
        },
        {
            id: 310113,
            name: '宝山区',
            bgcolor: '#bec7d2',
            popup: {x: 232.57, y: 349.03},
            data: [
                {
                    type: 'path',
                    val: 'M503.29,377.4c-9.46-4.41-12.19-10-8.81-18.6a15.11,15.11,0,0,1,4.1-6s.35-3.84-5-9a78,78,0,0,0-8.9-7.63s-7.42.56-7-1.3,2-1.12,2-2.05S470,323.08,468.14,322s-2.23,2.23-5.19-2.23a18.06,18.06,0,0,0-3.52-1.86c-1.3-.37,2.42-1,.68-2.84s-6.9-2.74-8.84-5.53-33.19-26.42-45.15-28.65l-6.4,4.19s-6.86-5.58-9.64-1.3.74,5,.74,5,6.12,6.05,7.23,10.51-1.11,7.26.56,10.79,8.53,11.35,9.09,16,.74,5.95-.37,6.7-3.15.74-3.15,1.86.56,3.72-.74,4.09-6.49.19-6.12,5.21,1.85,5.95,4.08,8.93.93,4.84,1.85,6.51,4.45,2.42,5.19,6.33-2.23,7.07-1.48,10.05,5.38,3.16,5.93,4.84-3,2.6-2.6,3.72,4.45,7.63,1.3,11.53-6.86,8.74-6.12,12.09a7.57,7.57,0,0,0,4.82-1.86c1.85-1.86,8.53-4.28,9.27-2.05s-3.15,5.21,2.41,6.33,9.09,1.12,10.2-.37,3.15-5,5.93.74,5.56,15.44,12.61,13.4,1.3-8.56,1.3-10.79.74-8.93,1.3-10.23,4.45-8.56,7.23-8.74,2.41.56,3.89,1.12,8.72-4.28,9.64-3.72-.37,4.28.74,4.47,7.79-1.49,8.16-.37,3.71,3.53,5.19,3.16.93-6.88,1.11-11.35,4.64-8.19,7.42-8a6.14,6.14,0,0,1,4.08,1.67l2.41-3.72Z'
                },
                {
                    type: 'text',
                    name: '宝山',
                    x: 232.57,
                    y: 349.03
                }]
        },
        {
            id: 310115,
            name: '浦东新区',
            bgcolor: '#fcdfbd',
            popup: { x: 389.5, y: 506.75},
            data: [
                {
                    type: 'path',
                    val: 'M522.26,396.05s2.23-11.16-12.65-16S489.89,369.26,494,358.84s10.42-6.33,10.42-6.33,6,5.95,10.79,5.58,16,2.23,25.67,10.05S568.39,383,584,395.3s29.4,29.77,52.09,61.4,14.14,21.58,40,41.67,31.63,29.4,31.63,29.4L693.6,540.42s17.67,31.26,24.37,44.65,17.86,41.67,18.6,45,0,18.23-2.6,23.44-37.58,21.21-42.42,21.58-20.84-2.23-20.84-2.23.42,2-.14,2.88-11.16,2.37-21.21-.14l-21.81,0s0-12.09,4.09-20.47,5.77-23.63,0-32.19a49.16,49.16,0,0,0-19.35-16.93c-6.7-3.35-7.63-8.19-9.86-10.23S594.06,588,574,587.11s-20.65,2-23.63-1.86-16.93-2.23-22.7-1.67c0,0-5.21-3-1.3-8.37s2-6.7.19-7.07-8.93,4.47-8.74.74,3.72-2.6,3.72-7.44.19-5.4-7.26-8.56,10-17.12,13.77-16.56a10.3,10.3,0,0,0-8.56-1.67c-4.84,1.3-7.63-6.33,5.58-6.88,0,0-3.77-3.67-3.77-7s1.26-5.3-.7-5.3-5,1.4-7.95.42-5.3-2.79-8.09-2.51-6.84,2.37-7.95.42-1-3.3-2.51-2.84-.65,4.74-2.42,4.37.72-2.7-2.16-3.81c0,0-.81,1.49-1.84,1.21s-1.3-4.65-3.26-3.72-3.72,2.33-3.81,4.28.93,6.79-4.47,2.79l-2.51-1.67s1.67-2.6.09-6.6-6.33-5.49-5.58-11.44,6.91-2.7,5-12.47c0,0-5.42-10.05,7.05-12.65s15.26-14.88,15.07-16.56-8.93-8.74-8.47-14.05S502,437,504.2,436.53s10.79-4.28,15.44-9.21,7.26-7,6.23-13.58S520.68,410.56,522.26,396.05Z'
                },
                {
                  type: 'path',
                  val: 'M685.05,435c-1.24-.7-4.19,2.7-2.14,7.63S690,450.52,693,456.19s11.26,10.7,13,9.86,3.53-6.88,3.91-10.33.19-11.07-2.23-11.53-3.9-.29-7.16-2.88S692,438.89,685.05,435Z'
                },
                {
                  type: 'path',
                  val: 'M724.87,444.29c-4.24,0-12.28,6.7-7.44,23.44,4.56,15.77,12.84,25.86,25.86,25.86s16.74-5.77,22-17.67,4.84-19.16-2.79-22.88c0,0-8.56.56-12.65-.56A148.43,148.43,0,0,1,733.24,446C731.56,445,727.1,444.29,724.87,444.29Z'
                },
                {
                    type: 'text',
                    name: '浦东',
                    x: 389.5,
                    y: 506.75
                }]
        },
        {
            id: 310151,
            name: '崇明区',
            bgcolor: '#8aadb9',
            popup: {x: 303.32, y: 195.4},
            data: [
                {
                    type: 'path',
                    val: 'M542.91,164.57s-20.93-9.49-30.7-18.7-26-12.56-26-12.56-22.33,2.79-35.72-17.58c0,0-4.19-6.14-1.4-7.81s-10.42-12.47-10.42-12.47-44.28-26.6-47.63-27-22.33,5.21-42.6,19.72-27.16,25.12-27.16,26.6,12.65,15.81,14.51,18,9.67,13,11.16,13.95,7.44,2.6,10.23,3.16,12.47,1.86,13,4.47c0,0-11.16,0-10.79,2.79s2.79,9.86,20.65,13.77c0,0,5.58-4.65,7.44-3.16,0,0,.6,1.21-1.14,2.47s6.28,9.07,6.28,9.07a7.08,7.08,0,0,1,3.91,3.49,11.2,11.2,0,0,1,1.67,5.09s7.88,5.93,11.05,9.65,11.16,5.4,15.07,9.67,6.14,8.37,9.86,9.49,33.86,13,68.09,33.12,41.3,23.44,52.84,25.67,30.14,3.72,53.21,18.23,44.28,27.53,55.07,30.14,24.93-3.35,24.93-3.35l.74-4.84s9.3,3,19.72-7.07l-2.6-2.23,10-7.81,7.44-16.37,13.77,5.21s8.93-17.49-18.6-36.84c0,0-24.56-28.28-39.07-31.26s-41.67-.37-41.67-.37-48.74-14.88-51-16.37,7.07-11.53,7.07-11.53-13,2.6-24.56-15.26c0,0-22-13.77-24.93-14.88Z'
                },
                {
                  type: 'path',
                  val: 'M641.42,357.12a14.19,14.19,0,0,0,2,6.28c2,3.49,1.53,4.05,2.51,10.19s2.23,15.49,8.09,20.79,13.4,14.09,18,13.81,15.21-12.7,16.6-20.65-2.51-16.74-5.16-19.12S666,361.16,666,361.16s-5.72.42-7.12-.14a17.37,17.37,0,0,1-3.77-2.93S642.4,357,641.42,357.12Z'
                },
                {
                  type: 'path',
                  val: 'M515.43,292s-18.14-2.51-18.84.14-1.95,6.7,9.91,10.6,16.6,19.53,25.4,23.3,15.77,4.88,22.47,10.6,27.21,19.53,32.79,22.6,21.49,11.44,27.49,18.28,8.51,15.07,12.14,17a22.24,22.24,0,0,0,8.51,2.09s6,3.77,7.67,3.21-2.65-7.12-3.21-17.86,1.53-13.26-6.42-23.16-37.81-22.88-54-29c0,0-14.65-2.93-17.86-4.74a81.1,81.1,0,0,0-12-5.16c-1.4-.28-13.12,0-18.42-7.26s-5.3-13.81-8.09-15.49-8.23-1.26-8.23-1.26Z'
                },
                {
                  type: 'polygon',
                  points: '382.52 231.27 378.62 236.85 391.59 248.57 394.52 244.66 389.5 234.48 382.52 231.27'
                },
                {
                    type: 'text',
                    name: '崇',
                    x: 303.32,
                    y: 195.4,
                    tspan: {
                      dx: 8,
                      dy: 13.2,
                      txt: '明'
                  }
                }]
        },
        {
            id: 310110,
            name: '杨浦区',
            bgcolor: '#e6bbbd',
            popup: {x: 294,  y: 401},
            data: [
                {
                  type: 'path',
                  val: 'M488.2,399.08s-5.21-.28-5.3,0a27.25,27.25,0,0,0,.28,5.21c.28,1,1.74,5.72,2,5.72s4.95-1.6,5.3-1.47a1.3,1.3,0,0,1,.63,1.22c0,.52,0,1.71.49,2.06a14.27,14.27,0,0,1-1.47,1.5c-.28.14-1.74,1.33-1.81,2.16s.28,4.22.28,4.22a2.86,2.86,0,0,1,2.55,1,18.59,18.59,0,0,1,2.44,2.48,8.62,8.62,0,0,0,.07,3,9.37,9.37,0,0,0,1.81,2.44A33.5,33.5,0,0,1,498,432a18,18,0,0,1,1.19,2.06c0,.09-.63,0-.73.14s.21.45.21.8-.07,1.29-.07,1.29v.35c2.68,0,5,.07,5.75-.09,2.23-.47,10.79-4.28,15.44-9.21s7.26-7,6.23-13.58-5.21-3.16-3.63-17.67c0,0,2.23-11.16-12.65-16-2.43-.79-6.42-2.61-6.42-2.61l-.52.87-2,3a6.09,6.09,0,0,0-4.09-1.67c-2.79-.19-7.26,3.53-7.44,8s.37,11-1.12,11.34'
                },
                {
                    type: 'text',
                    name: '杨浦',
                    x: 294,
                    y: 401
                }]
        },
        {
            id: 310107,
            name: '普陀区',
            bgcolor: '#e6bbbd',
            popup: { x: 239.5, y: 428.68},
            data: [
                {
                    type: 'path',
                    val: 'M415.5,441.87c.93.09,4.65.19,5.4-1a5,5,0,0,1,2.23-2.23c.74-.28,3.26.28,4.19-.47s2.88-4.09,2.79-5.49-1.95-3.26-2.7-3.53-4.28.65-5.12,0-3.07-2.51-2.88-3.35,5-2.14,4.09-4.28-8-2.7-9-2.51-4.84,4.65-6.6.28-.93-6.6-4.19-6.23.84-3.07,1.3-3.53a19.92,19.92,0,0,1,3.16-1.58l2.14-1.86c1.85-1.86,8.53-4.28,9.27-2.05s-3.15,5.21,2.41,6.33,9.09,1.12,10.2-.37,3.15-5,5.93.74,5.56,15.44,12.61,13.4c2.66-.77,3.5-2.18,3.51-3.75h0a13.14,13.14,0,0,0,4.49,3.48c2.42.93,3.16,1.49,5.86,6l1,1.81s-1,1.3-.51,1.91.93.28.23,2.33-1.44,2.19-1,2.6,1.21.88-.33,1.44a33,33,0,0,0-4.47,2.65c-.84.47-1.44,1.49-2.65,1.58s-1.16-.28-1.44-.05a5.62,5.62,0,0,0-1.72,3.91l-.45-.69a1,1,0,0,0-.79.28c-.59.49-.48.08-.57.13s-1.33,1.88-2,2-1.14-1.6-2.07-1.84-.35.51-.16.81a2.56,2.56,0,0,1,.12,1.67c-.18.39-2.23,1-2.91,1s-.95.23-2.16.79-2,0-2.6.23-.23,1.12-.51,1.4-.84,0-1.3-.19-2.33.19-3.26.14a16.12,16.12,0,0,1-3.12-.74,11.61,11.61,0,0,0-2.19-.09c-.52,0-.79-.33-1.53-.42s-.74.47-1.4.42-.47-.7-1.12-1.35-1.77-.51-2.23-.84-1.86-1-3-1.72-4.09-7.07-4.09-7.07'
                },
                {
                    type: 'text',
                    name: '普陀',
                    fs: 12,
                    x: 239.5,
                    y: 428.68
                }]
        },
        {
            id: 310112,
            name: '闵行区',
            bgcolor: '#e6bbbd',
            popup: { x: 259.32, y: 542.42},
            data: [
                {
                  type: 'path',
                  val: 'M398.11,487.89l2.4,3.17c2.14,1.54,4.15,6.22,4.42,6.77s1.8,2.65,2.21,3.7,2.35,1.4,2.76,2.3,1.18,1.47,1.59,3.28,2.63,4,2.9,5.8a6.18,6.18,0,0,0,1.31,3.63c1,1.47,1.66,2.44-.07,3.35s-.83,4.75-.35,4.68,3.46-1.33,3.94-1.19.9,3.14,1.31,3.84,3.53,4.12,4.42,5.38,2.21,3.91.9,4-5.25.07-5.39.91,1.45,4.26-1.24,6.35-5.39,4.12-9.33,4c0,0-1-2.16-2.21-1.47s0,6.84-.35,9.78-1.66,13.48-1.73,15-.76,3.91,1.24,3.49,2.76-2.1,3.59-1.4.28,3.42-1.38,5.66-3,5-5.94,7.26-2.14,8.45-1.59,8.59,3.25-.7,5.18.28,3.32,2.86,5.39,2.72,8.78-1.82,8.78-1.82l2.23-.76,5.07-1.82c13-4.19,17.69-3.77,22.81-6.7s6.77-6.42,9.68-7.4,6.77-.14,9.82-.7,6.08-3.77,8.16-4.05,5.11-1,6.22-.7,2.49-.28,2.9,8.52c0,0,1.52,1.54,2.76.56s6.91-4.19,9.26-2.65.28,4.19,6.5,5.17,7.19-.56,9.68,4.61a16.66,16.66,0,0,0,5-3.91c2.49-2.79,6.36-2.14,6.31-2.47s-5.16-3-1.29-8.38,2-6.7.18-7.08-8.85,4.47-8.66.74,3.69-2.61,3.69-7.45.18-5.4-7.19-8.57,9.95-17.13,13.64-16.57a10.16,10.16,0,0,0-8.48-1.68c-4.79,1.3-7.56-6.33,5.53-6.89,0,0-3.73-3.68-3.73-7s1.24-5.31-.69-5.31-5,1.4-7.88.42-5.25-2.79-8-2.51-6.77,2.37-7.88.42-1-3.31-2.49-2.84-.65,4.75-2.4,4.38.71-2.7-2.14-3.82c0,0-.81,1.49-1.82,1.21s-1.29-4.66-3.23-3.72-3.69,2.33-3.78,4.28.92,6.8-4.42,2.79l-2.49-1.68a34.27,34.27,0,0,0-2.44,2.68c-.35.56-.55,4.33-.69,5.17s-4.63,1.12-5.53,1.12-2.9-2-3.11-2.79,1.59-1.47,1.94-1.82a2.54,2.54,0,0,0,.35-2.72c-.62-1-1.45-.07-4.7.77s-1.73-.84-1.45-1.75a18.22,18.22,0,0,0,.14-7.12c-.62-2.1-1-1.19-1.87-1.68s-7.33,1.68-7.81,1.47-8.09-19.2-8.71-20-2,2.72-3.59,1,1.24-2.44,1.24-2.79-2.7-.35-3.11-.42-.28-2.16-.28-2.37,2.35-.42,2.7-.84-1.52-2.1-1.66-2.37-.07-2.23.21-2.3l8.78-2.23c.76-.21,1.87-1,1.87-1.33s-1.87-4.4-2.35-4.68-8.57.42-9.4.49-6.15,2-7.26,2.37a39.51,39.51,0,0,1-6.15.28c-.41,0-9.4,7.47-9.82,7.4s-5.18-9.29-5.32-9.78,1.45-1,1.94-1.61-.07-3.42-.14-6.7a17.37,17.37,0,0,1,.83-5.38,4.55,4.55,0,0,1,1.38-2.23c.27-.2-.21-6.77-.14-8.24s-.21-1.19-.9-1.33-1.18-3.27-1.18-3.27-2.82,2.73-6,5.57c-1.37,1.23-4.38,1.3-10.35.37s-7.08-2.61-9.32-6.24-3.64-4.1-6.8-6.33a24.21,24.21,0,0,0-7.7-3.78l-1-.15s-4.61.84-6.71,3.77-2.1,4.89-1.12,5.87,3.22-.84,5.45,1.68a11.1,11.1,0,0,1,3.08,7.12c0,2,2.24,5.45,1.68,6.29s-.84,1.82.84,3.07c0,0,1.68-1.47,1.61.28s-.84,3.42,1.54,5.52,3.64,4.19,6.71,2.72,4.82-3.28,5.87-2.72,2.38,4.47,3.43,5.38,2.59,1.05,3.15,3.07,2.94,5,4.05,6.49,2.7,7.19,2.38,8.43l-.13.07'
                },
                {
                    type: 'text',
                    name: '闵行',
                    x: 259.32,
                    y: 542.42
                }]
        },
        {
            id: 310104,
            name: '徐汇区',
            bgcolor: '#bec7d2',
            popup: {x: 248.46, y: 480.47},
            data: [
                {
                    type: 'path',
                    val: 'M473.77,514.42s1.67-2.6.09-6.6-6.33-5.49-5.58-11.44,6.91-2.7,5.05-12.47c0,0-4.68-8.67,4.66-12v0s-.2-1-.44-1.1-1.91-.23-2.09-.51-.19-2.42-.37-3.07a17,17,0,0,1-.84-2.6,12.66,12.66,0,0,0-.65-2.28,5.71,5.71,0,0,1-1,.65,12.78,12.78,0,0,1-1.35.33,38,38,0,0,0-.7-6.09c-.27-1-1.19-3.14-1.65-4.26l-.09,0-.42.09c-.42-.09-3,1.91-3.49,2.09s-5.12,1.3-5.3,1.26l.07.24a2.32,2.32,0,0,1-1.07,1.21,2.18,2.18,0,0,1-1,.19l1.35,4.23a13.22,13.22,0,0,1-1.81,1.3c-.47.19-4.88,2.23-5.12,2.33a6.29,6.29,0,0,0-.93,1.3s-.42,0-.47.05a1.76,1.76,0,0,1,.28,1.95c-.51,1.4-2.33.74-2.6.7s.23-.84-.09-.88-.93.88-.93.88l-2.56-.14h-.51a25.59,25.59,0,0,1,2,4.26c0,.35-1.11,1.12-1.87,1.33s-8.5,2.16-8.78,2.23-.35,2-.21,2.3,2,2,1.66,2.37-2.7.63-2.7.84-.14,2.3.28,2.37,3.11.07,3.11.42-2.83,1.05-1.24,2.79,3-1.75,3.59-1,8.23,19.76,8.71,20,6.91-2,7.81-1.47,1.24-.42,1.87,1.68a18.2,18.2,0,0,1-.14,7.12c-.28.91-1.8,2.58,1.45,1.75s4.08-1.82,4.7-.77a2.53,2.53,0,0,1-.35,2.72c-.35.35-2.14,1-1.94,1.82s2.21,2.79,3.11,2.79,5.39-.28,5.53-1.12.35-4.61.69-5.17,2.34-2.66,2.34-2.66Z'
                },
                {
                    type: 'text',
                    name: '徐汇',
                    fs: 12,
                    x: 248.46,
                    y: 480.47
                }]
        },
        {
            id: 310118,
            name: '青浦区',
            bgcolor: '#bec7d2',
            popup: {x: 106.99, y: 480.59},
            data: [
                {
                  type: 'path',
                  val: 'M253.17,609.68c.7-.84,2.65.56,3.21-.56s-2.37-7.67,1.53-7,5.58,7.4,9.63,8.51,5.44.14,6.42-1.26,2-3.49,2.65-3.77,5.16,1.53,6-2,1.95-12.42,2.37-14.51.28-2.37,1.81-2.93-.42-8-.7-9.21-2.93-2.79-3.35-4.47-4.6-3.07-4.74-3.91a1.79,1.79,0,0,1,3.07-1.12c1.67,1.4,3.63-1.4,4.05-2.93a7.61,7.61,0,0,0-.42-3.77s-2.37-.14-2.51-1.81a15.72,15.72,0,0,0-.7-4c-.42-1.19-5.58-3.77-5.3-5s4.33-7,5.93-4.33,3,7.88,4.88,6.7.14-2,1.95-2.44,11,1.33,11.44-1.4-3.7-4.93-4.72-6-3.35-5.3-4.19-6-5.49-.56-5.49-1.12.65-3.63.47-4.47-3.35-4.09-2.7-6.23,1.77-.84,1.77-.84a2.83,2.83,0,0,0,3.16-.84c1.12-1.58,1.77-4.56,3.91-4.65s5.58,3,6.6,4,3.07,4.19,3.81,3.63,3.53-.37,4.28.28,1.21,2,2.7,2,4.37.56,4.47-1.49-1.49-2.79-.65-3.16,4.56,1.21,5.58.37,1-3.16,1.21-4,3.07-1.86,3.35-3,0-3.35,1.3-3.53,3.81-.19,4.19-1.3-2.7-4.47-2.6-6.23.19-7.91,1.4-8.19,3.35,1.4,4.74,1.86,4.47.09,5.3.37,3.26,2.6,4.56,2.33,6.23-3.26,7.44-2.14-3.72,9.49-3.63,10.7-.65,5.77,4.28,4.37,3.91-3.35,4.37-5.4,3.53-.47,4.09-1.58-2.33-1.3-2.23-2.05,3-2.7,4.56-2.6a12.71,12.71,0,0,1,3.63.37c.84.37,1.4,4,2.79,3.63s-.47-3.53,1-4,7.72.28,9-.28,3.35-2.23,2.7-4.19-3.53-1.21-4.37-1.3.56-2.14.56-3.44.74-1.58,1.77-1.95,3.07.93,4.09.93,2.6-.74,4.09-.37,3.72-2.05,4.93-3.07,4-3,6.14-2.05l.12-.07c.33-1.23-1.26-6.95-2.37-8.42s-3.49-4.47-4-6.49-2.09-2.16-3.14-3.07-2.37-4.81-3.42-5.37-2.79,1.26-5.86,2.72-4.33-.63-6.7-2.72-1.6-3.77-1.53-5.51-1.6-.28-1.6-.28c-1.67-1.26-1.4-2.23-.84-3.07s-1.67-4.33-1.67-6.28A11.15,11.15,0,0,0,364,442.2c-2.23-2.52-4.47-.7-5.44-1.67s-1-2.93,1.12-5.86,6.7-3.77,6.7-3.77l.66.23a21.84,21.84,0,0,0-2.29-.55c-2.6-.47-3.53.74-4.47.37s-2.23-2.51-3.26-2.88-4.28.56-6.51.56-4.37,4.56-5.12,4.56-.56-3-4.37-2.88-6.33,4.09-7.26,4.47-2.14-1.49-3.44-1.67-1.67.37-3.07,1.12-1.77-.84-2.42-2.23-2.05-.84-2.6-.65-1.21-.65-1.95-1.67a18.34,18.34,0,0,1-1.58-3.72c1-1.58.09-4-1.12-4.37s-3.91,2.33-5.3,2.6-.65-4.47-.65-5.3c0,0-6.7.09-8.56-1.49s-5.21-3.91-8-3.72-6.14,5.12-8.28,4.93-2.6-9.58-7-9.49-3.72,8.65-3.35,9,1.86,2.6-.56,3.72-8.37.47-9.3,1.3-.65,10.42-.65,10.42-1,3.63.47,12,2.05,20.47,3.53,24,4.81,16.95,3.14,19.4-3.14,4.81-4.05,5-2.23-.91-3.14-1.95-3.35.7-3.35,1.6-2.86.42-3.35.07.07-3.42-2.16-2.16a3.57,3.57,0,0,0-1.74,4.19c.28.49,2.58,1.6,1.53,3.07s-2.14,4.16-4.37,2-3.44-4.65-4.65-3.44-2.23,5.86-4.84,6.23-10.23-.56-12.09-.19-4.09,1.86-8.74.74-20.47-5.21-23.07-5-11.35,4.09-13.77,3.72-5-.93-5.77-.93-6.14-.37-7.63.74A13.55,13.55,0,0,0,168,509c-.56,2.23,0,3.91-1.3,4.47s-6.7,4.09-6.14,6a8.16,8.16,0,0,0,5,5.21c2.6.74,3.16-2,4.28-2s1.86,3.91,4.47,4.28,3.91-2.6,4.65-2,.19,2.23,1.12,3.16,5.95,7.44,5.58,8.37-2.23-1.86-3.53,0-1.67,9.67-2,13.58,4.47,11,4.28,14.14-1.86,8.19-1.3,8.74,3.35-.74,4.47.37,1.3,3.91,2.05,3.91,1.86-1.86,5-1.12,6.14,2.42,7.44,1.67-1.49-4.09-1.67-5.21,5.21.93,6.33.19,3.16,0,1.3-6.33c0,0,2.05-1.86,3.72-.56s2.79,7.44,4.84,8.19,8.93-1.3,10.6.56a13.59,13.59,0,0,1,3,7.81c0,2.42-2.23,2.23-1.12,3.53s6.51,6.88,5.77,10.42-8,6.14-4.84,12.84l2.47,3.21s1.81-1.67,4.05,2.51a3.56,3.56,0,0,0,3.77-1.26c1.4-2,.42,3.35,1.53,4.05s1.67,1.4,3.91.7,2.72-.53,4-1.81C253,613.31,252.47,610.52,253.17,609.68Z'
                },
                {
                    type: 'text',
                    name: '青浦',
                    x: 106.99,
                    y: 480.59
                }]
        },
        {
            id: 310117,
            name: '松江区',
            bgcolor: '#8aadb9',
            popup: {x: 147.97, y: 568.38},
            data: [
                {
                  type: 'path',
                  val: 'M416.43,635.43c-.12.09-2.19-1.24-3.31-1.24s-3.35,5.58-7.4,3.63-5.86-1-9.91-1.4-5.3,1-7.12.84-.7-5.86-2.37-6.14a3,3,0,0,0-3.49,3.07c.14,1.95,1.26,7.4.42,8.79s-5,5.16-9.77-.84-5.16-3.91-9.77-5.44-2.37-3.49-3.77-7.12-6-4.19-9.35-3.63-1.4,2.79-6.84,4.74-13.95,2.79-13.95,2.79-1.53.28-2.65.42a17.73,17.73,0,0,1-5-.42c-2.23-.42-2.37-1-4.47-1.4s-2.09,1.67-3.49,1.81-2.79-.28-5.86-1.67-3.35.42-3.07,1.81,0,0,1.12,2.23.42,4.88-.84,4.88-1.95,1.53-2.93,1.67-.28-2.09-2.79-2.23-5.3,3.63-7.4,2.65,4.6-10.05,3.63-12.7-6.28-1.53-8.65-1.95-12.7,5.16-7,7,3.21,4.88,2,5.58-7.53-2.79-11.16-2.37-8.23,3.91-13.26,4.05-10.33-6.14-11.16-7.26,3.43-9,3.91-13.81c.37-3.74-1-5.26-1-5.26,3.3-3.21,2.79-6,3.49-6.84s2.65.56,3.21-.56-2.37-7.67,1.53-7,5.58,7.4,9.63,8.51,5.44.14,6.42-1.26,1.95-3.49,2.65-3.77,5.16,1.53,6-2,2-12.42,2.37-14.51.28-2.37,1.81-2.93-.42-8-.7-9.21-2.93-2.79-3.35-4.47-4.6-3.07-4.74-3.91a1.79,1.79,0,0,1,3.07-1.12c1.67,1.4,3.63-1.4,4.05-2.93a7.61,7.61,0,0,0-.42-3.77s-2.37-.14-2.51-1.81a15.72,15.72,0,0,0-.7-4.05c-.42-1.19-5.58-3.77-5.3-4.95s4.33-7.05,5.93-4.33,3,7.88,4.88,6.7.14-2,1.95-2.44,11,1.33,11.44-1.4-3.7-4.93-4.72-6-3.35-5.3-4.19-6.05-5.49-.56-5.49-1.12.65-3.63.47-4.47-3.35-4.09-2.7-6.23,1.77-.84,1.77-.84a2.83,2.83,0,0,0,3.16-.84c1.12-1.58,1.77-4.56,3.91-4.65s5.58,3,6.6,4,3.07,4.19,3.81,3.63,3.53-.37,4.28.28,1.21,2.05,2.7,2.05,4.37.56,4.47-1.49-1.49-2.79-.65-3.16,4.56,1.21,5.58.37,1-3.16,1.21-4,3.07-1.86,3.35-3,0-3.35,1.3-3.53,3.81-.19,4.19-1.3-2.7-4.47-2.6-6.23.19-7.91,1.4-8.19,3.35,1.4,4.74,1.86,4.47.09,5.3.37,3.26,2.6,4.56,2.33,6.23-3.26,7.44-2.14-3.72,9.49-3.63,10.7-.65,5.77,4.28,4.37,3.91-3.35,4.37-5.4,3.53-.47,4.09-1.58-2.33-1.3-2.23-2.05,3-2.7,4.56-2.6a12.35,12.35,0,0,1,3.63.37c.84.37,1.4,4,2.79,3.63s-.47-3.53,1-4,7.72.28,9-.28,3.35-2.23,2.7-4.19-3.53-1.21-4.37-1.3.56-2.14.56-3.44.74-1.58,1.77-1.95,3.07.93,4.09.93,2.6-.74,4.09-.37,3.73-2,4.93-3.07a7.85,7.85,0,0,1,6.14-2l2.42,3.16c2.16,1.53,4.19,6.21,4.47,6.77s1.81,2.65,2.23,3.7,2.37,1.4,2.79,2.3,1.19,1.47,1.6,3.28,2.65,4,2.93,5.79a6.09,6.09,0,0,0,1.33,3.63c1.05,1.47,1.67,2.44-.07,3.35s-.84,4.74-.35,4.67,3.49-1.33,4-1.19.91,3.14,1.33,3.84,3.56,4.12,4.47,5.37,2.23,3.91.91,4-5.3.07-5.44.91,1.47,4.26-1.26,6.35-5.44,4.12-9.42,4c0,0-1.05-2.16-2.23-1.47s0,6.84-.35,9.77-1.67,13.47-1.74,15-.77,3.91,1.26,3.49,2.79-2.09,3.63-1.4.28,3.42-1.4,5.65-3.07,5-6,7.26-2.16,8.44-1.6,8.58,3.28-.7,5.23.28,3.35,2.86,5.44,2.72,8.86-1.81,8.86-1.81l2.25-.76c-7.35,3-4.43,4.87-3.95,8.92.56,4.74,3.35,17.3.28,17.86s-6.42,3.35-4.19,10.05A16.82,16.82,0,0,1,416.43,635.43Z'
                },
                {
                    type: 'text',
                    name: '松江',
                    x: 147.97,
                    y: 568.38
                }]
        },
        {
            id: 310116,
            name: '金山区',
            bgcolor: '#e6bbbd',
            popup: { x: 172.25, y: 680.56},
            data: [
                {
                  type: 'path',
                  val: 'M416.63,635.45c2.26,6.72,5.17,15.25,5.17,15.25,11.72,3.63,9.77,10.88,9.77,10.88.56,16.19-2.23,17-2.23,17s5,10.6,8.65,5.58,3.91-1.12,3.07,1.4,8.09,7.53,8.09,7.53c9.21-8.37,22.88,22,22.88,22s-15.77,5.58-21.21,9.35-13,10.47-15.63,14.23c0,0-.19.89-1.31.19s-1.8-1.36-2.06-1.31-1.48.72-.21,1.67,2.78,1.72,2.88,2.42-.79,1.53-1.58,2.28-9.16,6.6-12,10-10.88,10.6-19.26,11.16S397,762.59,389.42,764s-13.12,1.95-15.63,3.63c0,0-3.63-10.05-2.79-13.4s3.63-7-1.12-14.51-13.12-5.58-16.47-10.88-1.12-20.65-12.56-19c0,0-5.58,1.4-4.47,7,0,0-.47,1.4-1.95.28s-1.21-3.91-4.84-1.58-4,2.88-7.81.84c0,0-2.6,2.42-4.28,1.86s-4.19-4.28-8.84-4.37-4.65,4-8.93,2.33.19-18.33.19-18.33l3.53-10.51a5.55,5.55,0,0,0-.74-4.84c-1.67-2-6.79,0-7.77-3.21s2.51-2.79,2.37-4.19-5.16-6-6.84-6-.84,3.35-3.35,3.07-1.95-4-4.05-4.33-4.05,5.44-8.79,5.86-7.4-1.81-9.63,5.44c0,0-3.91,2.93-5.3,3.91s.84,3.77-1.53,4.47-2.23-3.63-3.63-2.51,4.33,8.37,1.26,9.35-5-5.16-5.3-8-7.12-6.14-9.63-5.86-2.09,5.3-4.19,5-3.91-.14-5.44,2.79-4.33-6.42-.56-10.47,10.47-9.91,11.3-12.56-.28-4.05,1-5.3,1.81-4.47,1-5.86-4.88,0-5.72-1.12,1.67-3.21.84-4.33-7,2.37-8.51,0-1-8.09.7-8.79,4.6-.56,5.58-2.51c0,0-5.16,1.81-3.63-6.28s1.67-9.77-.7-15.35a3.82,3.82,0,0,0,.28-3.77s1.81-1.67,4,2.51a3.56,3.56,0,0,0,3.77-1.26c1.4-1.95.42,3.35,1.53,4.05s1.67,1.4,3.91.7a20.56,20.56,0,0,0,4.05-1.81s1.81,1,.84,5.72-4.74,12.7-3.91,13.81,6.14,7.4,11.16,7.26,9.63-3.63,13.26-4,9.91,3.07,11.16,2.37,3.77-3.77-1.95-5.58,4.6-7.4,7-7,7.67-.7,8.65,2-5.72,11.72-3.63,12.7,4.88-2.79,7.4-2.65,1.81,2.37,2.79,2.23,1.67-1.67,2.93-1.67,1.95-2.65.84-4.88-.84-.84-1.12-2.23,0-3.21,3.07-1.81,4.47,1.81,5.86,1.67,1.4-2.23,3.49-1.81,2.23,1,4.47,1.4a17.75,17.75,0,0,0,5,.42c1.12-.14,2.65-.42,2.65-.42s8.51-.84,13.95-2.79,3.49-4.19,6.84-4.74,7.95,0,9.35,3.63-.84,5.58,3.77,7.12,5-.56,9.77,5.44,8.93,2.23,9.77.84-.28-6.84-.42-8.79a3,3,0,0,1,3.49-3.07c1.68.28.56,6,2.37,6.14s3.07-1.26,7.12-.84,5.86-.56,9.91,1.4,6.28-3.63,7.4-3.63a12.53,12.53,0,0,1,3.49,1.12'
                },
                {
                    type: 'text',
                    name: '金山',
                    x: 172.25,
                    y: 680.56
                }]
        },
        {
            id: 310120,
            name: '奉贤区',
            bgcolor: '#b4cddd',
            popup: {x: 319.18, y: 639.91},
            data: [
                {
                  type: 'path',
                  val: 'M628,675.59s0-12.09,4.09-20.47,5.77-23.63,0-32.19A49.16,49.16,0,0,0,612.77,606c-6.7-3.35-7.63-8.19-9.86-10.23S594.54,588,574.44,587s-20.65,2.05-23.63-1.86-16.93-2.23-22.7-1.67c0,0-4.14-.19-6.65,2.6a16.78,16.78,0,0,1-5,3.91c-2.51-5.16-3.49-3.63-9.77-4.6s-4.19-3.63-6.56-5.16-8.09,1.67-9.35,2.65-2.79-.56-2.79-.56c-.42-8.79-1.81-8.23-2.93-8.51s-4.19.42-6.28.7-5.16,3.49-8.23,4.05-7-.28-9.91.7-4.6,4.47-9.77,7.4-9.91,2.51-23,6.7-9.21,5.86-8.65,10.6,3.35,17.3.28,17.86-6.42,3.35-4.19,10,6.42,19,6.42,19c11.72,3.63,9.77,10.88,9.77,10.88.56,16.19-2.23,17-2.23,17s5,10.6,8.65,5.58,3.91-1.12,3.07,1.4,8.09,7.53,8.09,7.53c9.21-8.37,22.88,22.05,22.88,22.05s25.67-12,26.51-14.23l-2.79-4.74,11.44-3.63,1.67,4.19,42.7-12.84,1.12-2.51,20.58-3,.21-1.4,22.84-1,.19-1.3,15.63-.74-.19,2.23Z'
                },
                {
                    type: 'text',
                    name: '奉贤',
                    x: 319.18,
                    y: 639.91
                }]
        },
        {
            id: 310109,
            name: '虹口区',
            bgcolor: '#8aadb9',
            popup: {x: 278, y: 410.51, },
            data: [
                {
                  type: 'path',
                  val: 'M498.65,436.66v-.35s.07-.94.07-1.29-.31-.7-.21-.8.7-.05.73-.14a16.58,16.58,0,0,0-1.19-2.06,30.7,30.7,0,0,0-2.55-3.45,8.92,8.92,0,0,1-1.81-2.44,8.62,8.62,0,0,1-.07-3,19.28,19.28,0,0,0-2.44-2.48,2.86,2.86,0,0,0-2.55-1s-.35-3.38-.28-4.22,1.53-2,1.81-2.16a14.27,14.27,0,0,0,1.47-1.5c-.45-.35-.52-1.53-.49-2.06a1.3,1.3,0,0,0-.63-1.22c-.35-.14-5,1.47-5.3,1.47s-1.74-4.7-2-5.72a27.25,27.25,0,0,1-.28-5.21c.09-.28,5.26.17,5.29.07s-3.71-.58-5.2-3.24c-.58-1-8.08.78-8.47.14,0,0-.38,5.93-.49,6s-2,0-2.09.17.56,2.62.52,2.93a7.9,7.9,0,0,0-.19.84,3.58,3.58,0,0,1-.33,2.48s-.44,1.52-.51,1.66-.38.12-.49.37a4.63,4.63,0,0,1-.44.8c-.12.17-.44.51-.07.85s.4,1.26.54,2.16a8.47,8.47,0,0,1-.1,2c0,.21.3.63.28.82s0,.47-.07.54-.13,0-.16.24.16.45.17.56,0,.65,0,.73a6.19,6.19,0,0,0,.46,1.06c.13.13.39-.1,1.12.89s1.85,2.79,2,3.1a6.41,6.41,0,0,0,1.24,1.51c.78.79,1.8,2,1.92,2.08a11.07,11.07,0,0,1,1.32,1.13,6.1,6.1,0,0,0,1.24,1.15s.09,1.23.11,1.44a2.39,2.39,0,0,1-.12,1c-.13.26-.4.57-.34.65l.81,1.09s.27.4.23.47-1.1.43-1.09.49a11.79,11.79,0,0,1,.81,1.05c0,.18.38,1.13.42,1.33a11.06,11.06,0,0,0,.33,2l.2.47s1.33-1.47,1.85-1.53a10.06,10.06,0,0,1,2.7.83,5.71,5.71,0,0,1,.89.43s.22-1.1,2.2-1.92C492.44,436.73,498.65,436.66,498.65,436.66Z'
                },
                {
                    type: 'text',
                    name: '虹',
                    x: 278,
                    y: 410.51,
                    fs: 12,
                    tspan: {
                        dx: 0,
                        dy: 13.2,
                        txt: '口'
                    }
                }]
        },
        {
            id: 310101,
            bgcolor: '#e6bbbd',
            name: '黄浦区',
            popup: {x: 282.73, y: 450.48},
            data: [
                {
                  type: 'path',
                  val: 'M486.54,439.56a2.52,2.52,0,0,1,.66.35c.13.15-.19.28-.22.79-.36,5.31,8.28,12.37,8.47,14.05s-2.6,13.95-15.07,16.56a18.63,18.63,0,0,0-2.45.68s-.2-1-.44-1.1-1.91-.23-2.09-.51-.19-2.42-.37-3.07a17,17,0,0,1-.84-2.6,12.66,12.66,0,0,0-.65-2.28,5.71,5.71,0,0,1-1,.65,12.78,12.78,0,0,1-1.35.33,38,38,0,0,0-.7-6.09c-.33-1.16-1.58-4.05-1.86-4.79a5.34,5.34,0,0,1-.28-1.63s3.21,0,3.67,0,1.84.07,1.84.07l.21-1.33a3.9,3.9,0,0,1-.35-1.81,26.62,26.62,0,0,0-.44-3.14,14,14,0,0,0-1-2.23l-.67-1.95c1.37-.16,2.23.88,3,1.16s1.42-.26,2-.65,1.37-1,2.4-.37,1.49.6,2,.4,1.81-2.23,2.65-2.37,2.92.88,2.92.88'
                },
                {
                    type: 'text',
                    name: '黄浦',
                    fs: 12,
                    x: 282.73,
                    y: 450.48
                }]
        },
        {
            id: 310105,
            bgcolor: '#bec7d2',
            name: '长宁区',
            popup: {x: 223.32, y: 458.91},
            data: [
                {
                  type: 'path',
                  val: 'M407.49,441.42s.44,2.73.92,3.05.95.21,1,.42a11.23,11.23,0,0,1,.09,1.73c0,.38.17,3.84.17,3.84l.08,2.32s0,1.26,0,1.33-1,1.17-1.15,1.51a7.09,7.09,0,0,0-.4,1.34c0,.19-.51,1.72-.57,2.17a23.57,23.57,0,0,0-.14,2.58c0,.71,0,1.39.05,1.54s.19,2.53.23,2.81a8.27,8.27,0,0,1-.07,2.37,16.52,16.52,0,0,1-1.87,1.4c-.17.2-.22.22,0,.78s3.7,7,3.7,7,1.36,2.28,1.45,2.33,5.76-4.39,6-4.57,3.56-2.81,3.8-2.83,3.14,0,3.74,0a17.33,17.33,0,0,0,2.33-.24c.26-.08,4.71-1.63,4.86-1.67s2-.67,2.22-.69.77-.09.9-.09l4.12-.3s3.09-.2,3.34-.2a3.8,3.8,0,0,1,1.31.09c.2.15.35.38.53.41s.93,0,1.19.05l1.83.11s.76-1,1-.9-.06.78,0,.83,1.65.48,2.21,0a2.47,2.47,0,0,0,.62-1.72c0-.21-.4-.79-.39-.86s.33,0,.42-.05A11.82,11.82,0,0,1,452,466l4.42-2a8.37,8.37,0,0,0,1.41-.72c.42-.31,1.1-.89,1.1-.89l-1.35-4.23a2.14,2.14,0,0,0,2.09-1.4s-1.47-3.07-1.56-3.5-.41-2.38-.41-2.59-.45-.84-.77-.8a7.78,7.78,0,0,0-1.78,1.26c-.21.21-1,.71-1.43-1l0-1.73s-.18-1-.41-1a1.36,1.36,0,0,0-.89.34c-.19.17-.34.19-.4.13s-.9.95-1,1.06-.86,1-1.14.87a21.47,21.47,0,0,1-1.5-1.58c-.15-.1-.71-.51-.92-.28s.31.74.38,1.09a2.58,2.58,0,0,1,0,1.32,2.66,2.66,0,0,1-1.52.82,5.9,5.9,0,0,1-1.58.25,18.25,18.25,0,0,0-2.36.93,5.4,5.4,0,0,1-1.79,0c-.54,0-.71.1-.78.57s0,.87-.26,1-.88-.2-1.21-.26-2.78.15-2.9.15a7.39,7.39,0,0,1-1.22-.15c-.39-.1-1.53-.38-1.7-.44a4,4,0,0,0-1-.26c-.32,0-1.4,0-1.61,0a12,12,0,0,1-1.37-.39,1.09,1.09,0,0,0-1,.12c-.37.28-.83.47-1.12,0a6.26,6.26,0,0,0-.67-1,2.14,2.14,0,0,0-.81-.47c-.32-.07-1.06-.17-1.19-.24l-1.84-1s-1.57-.92-1.64-1-3.51-6.23-3.56-6.3-.42-.68-.42-.68a2.44,2.44,0,0,1-.92,0,1.52,1.52,0,0,1-.65-1.15c-.14-.75-.28-1-.59-.85s-.59.85-.8.84-.4-.35-.54-.7-.59-1.17-1-1.17-.82-.05-2.28.85A6.31,6.31,0,0,0,407.49,441.42Z'
                },
                {
                    type: 'text',
                    name: '长宁',
                    fs: 12,
                    x: 223.32,
                    y: 458.91
                }]
        },
        {
            id: 310106,
            name: '静安区',
            bgcolor: '#fcdfbd',
            popup: { x: 258, y: 410, },
            data: [
                {
                  type: 'path',
                  val: 'M474.47,396.13s-.38,5.93-.49,6-2,0-2.09.17.56,2.62.52,2.93a7.9,7.9,0,0,0-.19.84,3.58,3.58,0,0,1-.33,2.48s-.44,1.52-.51,1.66-.38.12-.49.37a4.63,4.63,0,0,1-.44.8c-.12.17-.44.51-.07.85s.4,1.26.54,2.16a8.51,8.51,0,0,1-.1,2c0,.21.3.63.28.82s0,.47-.07.54-.13,0-.16.24.16.45.17.56,0,.65,0,.73a6.19,6.19,0,0,0,.46,1.06c.13.13.39-.1,1.12.89s1.85,2.79,2,3.1a6.41,6.41,0,0,0,1.24,1.51c.78.79,1.8,2,1.92,2.08a11.07,11.07,0,0,1,1.32,1.13,6.1,6.1,0,0,0,1.24,1.15s.09,1.23.11,1.44a2.39,2.39,0,0,1-.12,1c-.13.26-.4.57-.34.65l.81,1.09s.27.4.23.47-1.1.43-1.09.49a11.79,11.79,0,0,1,.81,1c0,.18.38,1.13.42,1.33a11.06,11.06,0,0,0,.33,2l.2.47a2.15,2.15,0,0,1-1.17,1,2.51,2.51,0,0,1-1.12-.26,4,4,0,0,0-1.35-.55,2.33,2.33,0,0,0-1.15.37l-1.18.79a2,2,0,0,1-.73.23,1.53,1.53,0,0,1-.88-.28c-.12-.08-1.17-.69-1.65-.9a1.55,1.55,0,0,0-1-.07l.67,2c.12.33.81,1.47.93,1.91a34.86,34.86,0,0,1,.53,3.88,2.64,2.64,0,0,0,.33,1.4l-.21,1.33-5.51-.07c.09,1.72.47,2.09.47,2.09l-.42.09c-.42-.09-3,1.91-3.49,2.09s-5.12,1.3-5.3,1.26a18.55,18.55,0,0,1-1.49-3.26c-.37-1-.05-2.79-.88-3.3s-2.14,1.81-2.88,1.35-.56-1.21-.7-3.12a5.65,5.65,0,0,1,1.72-3.91c.28-.23.23.14,1.44.05s1.81-1.12,2.65-1.58a32,32,0,0,1,4.47-2.65c1.54-.56.74-1,.33-1.44s.33-.56,1-2.6.23-1.72-.23-2.33.51-1.91.51-1.91l-1-1.81c-2.7-4.56-3.44-5.12-5.86-6.05a13.16,13.16,0,0,1-4.51-3.49c0-2.59-2.21-5.64-2.21-7,0-2.23.74-8.93,1.3-10.23s4.45-8.56,7.23-8.74,2.41.56,3.89,1.12,8.72-4.28,9.64-3.72-.37,4.28.74,4.47'
                },
                {
                    type: 'text',
                    name: '静',
                    fs: 12,
                    x: 258,
                    y: 410,
                    tspan: {
                        txt: '安',
                        dx: 0,
                        dy: 13.2
                    }
                }]
        }];

    }
}
